function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.04 23.999c-6.617 0-12-5.383-12-12s5.383-12 12-12 12 5.383 12 12-5.383 12-12 12zm0-23c-6.065 0-11 4.935-11 11s4.935 11 11 11 11-4.935 11-11-4.935-11-11-11z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.103 17.16a1.076 1.076 0 01-1.063-1.194V9.034a1.08 1.08 0 01.194-.751 1.057 1.057 0 01.869-.444c.209 0 .411.061.585.175l7.182 3.592c.561.281.645.681.645.894s-.084.613-.644.894l-7.182 3.591a1.065 1.065 0 01-.586.175zM9.09 8.84a.069.069 0 00-.057.079A.436.436 0 019.04 9v7a.525.525 0 01-.006.079.073.073 0 00.012.053c.008.01.022.024.045.028H9.1c.021 0 .032-.004.043-.012a.5.5 0 01.067-.041l7.214-3.607-7.212-3.607a.535.535 0 01-.07-.041.066.066 0 00-.04-.013l-.012.001z"
});

function SvgPlay(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "play.f35a7.svg";
export { SvgPlay as ReactComponent };